import React from "react";
import { Button, Col, Form, Row, Modal, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import TipopreguntaData from "../../../TipopreguntaData";
import * as Yup from "yup";
import { Formik } from "formik";
import { savePlantillaCuestionariosPregunta } from "../../../../redux/climalaboral/plantillaCuestionario/action";

const NewQuestion = (props) => {
  const schema = Yup.object().shape({
    pregunta: Yup.string().required("**Campo requerido"),
    tipo: Yup.string().required("**Campo requerido"),
    sub_objeto: Yup.string().required("**Campo requerido"),
  });

  const measurements = useSelector((store) => store.measurements.measurements);
  const measurementsLoading = useSelector(
    (store) => store.measurements.loading
  );

  const dispatch = useDispatch();

  const nuevaPregunta = (req) => {
    const valorPregunta = TipopreguntaData.find(
      (inde) => inde.id === parseInt(req.tipo)
    );

    req.cuestionario = parseInt(props.id);
    req.posicion = props.preguntas ? parseInt(props.preguntas.length) : 0;

    props.setShowModalPregunta(false);
    props.setValidatedPregunta(false);

    const _tipo = TipopreguntaData.find((t) => t.id === parseInt(req.tipo));

    if (
      _tipo.title.toLowerCase() === "Matriz/escala valoración".toLowerCase()
    ) {
      req.opciones = [
        {
          respuesta: `Opción 1`,
          valor: 1,
          posicion: 0,
        },
        {
          respuesta: `Opción 2`,
          valor: 1,
          posicion: 1,
        },
      ];
    } else {
      req.opciones = [
        {
          respuesta: `Opción 1`,
          valor: 1,
          posicion: 0,
        },
      ];
    }

    req = { preguntas_ids: req };
    dispatch(
      savePlantillaCuestionariosPregunta(
        req,
        props.preguntas,
        props.setPreguntas
      )
    );
  };

  return (
    <>
      <Modal
        show={props.showModalPregunta}
        onHide={() => props.setShowModalPregunta(false)}
      >
        <Formik
          validationSchema={schema}
          onSubmit={nuevaPregunta}
          initialValues={{
            sub_objeto: "",
            pregunta: "",
            tipo: "1",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            errors,
          }) => (
            <Form
              onSubmit={handleSubmit}
              noValidate
              validated={props.validatedPregunta}
            >
              <Modal.Header closeButton>
                <Modal.Title>Nueva Pregunta</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Form.Group as={Col} className="mb-3">
                    <Form.Label column sm="12" md="12">
                      Pregunta:
                    </Form.Label>
                    <Form.Control
                      id="pregunta"
                      name="pregunta"
                      isInvalid={touched.pregunta && errors.pregunta}
                      isValid={touched.pregunta && !errors.pregunta}
                      onBlur={handleBlur("pregunta")}
                      onChange={handleChange}
                      value={values.pregunta}
                      className="rounded-pill"
                      placeholder="Pregunta"
                    ></Form.Control>
                    {touched.pregunta && errors.pregunta && (
                      <div className="px-2">
                        <small className="text-danger">{errors.pregunta}</small>
                      </div>
                    )}
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col}>
                    <Row className="align-items-end">
                      <Col>
                        <Form.Label className="ml-2">
                          Tipo de pregunta:
                        </Form.Label>
                        <Form.Control
                          as="select"
                          id="tipo"
                          name="tipo"
                          isInvalid={touched.tipo && errors.tipo}
                          isValid={touched.tipo && !errors.tipo}
                          onBlur={handleBlur("tipo")}
                          onChange={handleChange}
                          value={values.tipo}
                          className="rounded-pill"
                        >
                          {TipopreguntaData
                            ? TipopreguntaData.sort((a, b) => {
                                if (a.nombre && b.nombre) {
                                  if (
                                    a.title.toLowerCase() ===
                                    b.title.toLowerCase()
                                  ) {
                                    return 0;
                                  }
                                  if (
                                    a.title.toLowerCase() <
                                    b.title.toLowerCase()
                                  ) {
                                    return -1;
                                  }
                                }
                                return 1;
                              }).map((item) => (
                                <>
                                  <option
                                    key={item.id}
                                    value={item.id ? item.id : ""}
                                  >
                                    {item.title ? item.title.toUpperCase() : ""}
                                  </option>
                                </>
                              ))
                            : null}
                        </Form.Control>
                        {touched.tipo && errors.tipo && (
                          <div className="px-2">
                            <small className="text-danger">{errors.tipo}</small>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col}>
                    <Row className="align-items-end">
                      <Col sm={measurementsLoading ? "10" : "12"}>
                        <Form.Label className="ml-2">Medición:</Form.Label>
                        <Form.Control
                          as="select"
                          id="sub_objeto"
                          name="sub_objeto"
                          isInvalid={touched.sub_objeto && errors.sub_objeto}
                          isValid={touched.sub_objeto && !errors.sub_objeto}
                          onBlur={handleBlur("sub_objeto")}
                          onChange={handleChange}
                          value={values.sub_objeto}
                          className="rounded-pill"
                        >
                          <option key="" value="" selected disabled>
                            Seleccione una medición
                          </option>
                          {measurements
                            ? measurements
                                .sort((a, b) => {
                                  if (a.nombre && b.nombre) {
                                    if (
                                      a.nombre.toLowerCase() ===
                                      b.nombre.toLowerCase()
                                    ) {
                                      return 0;
                                    }
                                    if (
                                      a.nombre.toLowerCase() <
                                      b.nombre.toLowerCase()
                                    ) {
                                      return -1;
                                    }
                                  }
                                  return 1;
                                })
                                .filter(
                                  (m) => m.objeto === props.plantilla.objeto
                                )
                                .map((item, index) => (
                                  <option
                                    key={item.id}
                                    value={item.id ? item.id : ""}
                                  >
                                    {item.nombre
                                      ? item.nombre.toUpperCase()
                                      : ""}
                                  </option>
                                ))
                            : null}
                        </Form.Control>
                        {touched.sub_objeto && errors.sub_objeto && (
                          <div className="px-2">
                            <small className="text-danger">
                              {errors.sub_objeto}
                            </small>
                          </div>
                        )}
                      </Col>
                      {measurementsLoading && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Form.Group>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  disabled={props.questionSaveLoader}
                  variant="primary"
                  type="submit"
                >
                  {props.questionSaveLoader && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Crear
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default NewQuestion;
